import React, { useEffect, useState, Component, useRef, useCallback, useMemo } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useLocation, useHistory } from 'react-router-dom';
import {
	Grid,
	Paper,
	TextField,
	Button,
	Typography,
	Box,
	Container,
	AppBar,
	Toolbar,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Menu,
	MenuItem,
	CssBaseline,
	Tabs,
	Tab,
	Fade,
	Card,
	CardContent,
	DialogActions,
	CircularProgress
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { sendDataToBackend, fetchUserDetails } from '../../../api/serverRequests';
import DefaultImage from '../../../assets/images/lead_logos/default.png';
import BackgroundImage from '../../../assets/images/background.jpg';
import HomeIcon from '@mui/icons-material/Home';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SearchIcon from '@mui/icons-material/Search';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ShareIcon from '@mui/icons-material/Share';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import BedIcon from '@mui/icons-material/Hotel';
import BathIcon from '@mui/icons-material/Bathtub';
import KitchenIcon from '@mui/icons-material/Kitchen';
import {
	getListingPropertyReport,
	getMLNumberByHomeIdPropertyReport,
	getAllNearbyActiveListings,
	getAllNearbySoldListings
} from '../../../api/serverRequests';
import LeadDetailTab from '../../comps/LeadPropertyDetails/LeadDetails';
import LeadNearbyActiveTab from '../../comps/LeadPropertyDetails/LeadNearbyActive';
import LeadNearbySoldTab from '../../comps/LeadPropertyDetails/LeadNearbySold';
import LeadMarketUpdate from '../../comps/LeadPropertyDetails/LeadMarketUpdate';
import LeadCityMarketUpdate from '../../comps/LeadPropertyDetails/LeadCityMarketUpdate';
import KulbirLeadCityMarketUpdate from '../../comps/LeadPropertyDetails/KulbirLeadCityMarketUpdate';
import KulbirLeadNeighbourhoodMarketUpdate from '../../comps/LeadPropertyDetails/KulbirLeadNeighbourhoodMarketUpdate';
import LeadShowingTips from '../../comps/LeadPropertyDetails/LeadShowingTips';
import LeadCaptureForm from '../../comps/LeadPropertyDetails/LeadCaptureForm';
import { useUserState } from '../../../hook/customerHook';
import {
	FacebookShareButton,
	TwitterShareButton,
	LinkedinShareButton,
	WhatsappShareButton,
	EmailShareButton,
	FacebookIcon,
	TwitterIcon,
	LinkedinIcon,
	WhatsappIcon
} from 'react-share';
import useLeadCaptureTracking from '../../../hook/useLeadCaptureTracking';

const useStyles = makeStyles((theme) => ({
	root: {
		overflowX: 'hidden',
		width: '100%',
		minHeight: '100vh',
		background: `url(${BackgroundImage}) no-repeat center center fixed`,
		backgroundSize: 'cover',
		color: '#fff'
	},
	container: {
		padding: theme.spacing(4),
		margin: '0 auto',
		maxWidth: '1000px',
		backgroundColor: 'rgba(255, 255, 255, 0.9)',
		borderRadius: '15px'
	},
	paper: {
		padding: theme.spacing(4),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
		position: 'relative'
	},
	heroImage: {
		width: '100%',
		height: 'auto',
		marginBottom: theme.spacing(4),
		borderRadius: '10px'
	},
	textField: {
		width: '100%',
		marginBottom: theme.spacing(2),
		borderRadius: '10px',
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				borderColor: '#004F2B'
			},
			'&:hover fieldset': {
				borderColor: '#00391E'
			},
			'&.Mui-focused fieldset': {
				borderColor: '#004F2B'
			}
		}
	},
	formWrapper: {
		marginTop: theme.spacing(2),
		width: '100%'
	},
	title: {
		fontWeight: 'bold',
		marginBottom: theme.spacing(2),
		textAlign: 'center',
		color: '#333'
	},
	sectionTitle: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(1),
		color: '#555'
	},
	submit: {
		marginTop: theme.spacing(3),
		backgroundColor: '#004F2B',
		width: '200px',
		height: '50px',
		display: 'block',
		marginLeft: 'auto',
		marginRight: 'auto',
		color: '#FFFFFF',
		borderRadius: '25px',
		boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
		transition: 'background-color 0.3s, transform 0.3s',
		'&:hover': {
			backgroundColor: '#00391E',
			transform: 'scale(1.05)'
		},
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			height: 'auto'
		}
	},
	appBar: {
		backgroundColor: 'transparent',
		boxShadow: 'none'
	},
	toolbar: {
		display: 'flex',
		justifyContent: 'space-between',
		color: '#fff'
	},
	addressField: {
		border: '2px solid #004F2B',
		borderRadius: '15px',
		padding: '10px',
		fontSize: '1.2rem',
		color: '#333',
		textAlign: 'center',
		marginBottom: theme.spacing(1),
		backgroundColor: '#f9f9f9'
	},
	inviteText: {
		color: '#555',
		textAlign: 'center',
		fontSize: '1.1rem',
		marginBottom: theme.spacing(3)
	},
	quickStats: {
		display: 'flex',
		justifyContent: 'center',
		gap: '2rem',
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
		flexWrap: 'wrap'
	},
	statItem: {
		display: 'flex',
		alignItems: 'center',
		gap: '0.5rem'
	},
	statIcon: {
		fontSize: '1.2rem',
		color: '#666'
	},
	statValue: {
		fontSize: '1.1rem',
		fontWeight: 500,
		color: '#333'
	},
	statLabel: {
		fontSize: '0.75rem',
		color: '#666',
		marginLeft: '0.25rem',
		textTransform: 'lowercase'
	},
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: theme.spacing(4),
		gap: theme.spacing(2)
	},
	loadingText: {
		color: '#333',
		fontWeight: 500,
		textAlign: 'center',
		marginBottom: theme.spacing(2)
	},
	dialogPaper: {
		borderRadius: '15px',
		padding: theme.spacing(2),
		maxWidth: '600px',
		width: '90%'
	},
	formTitle: {
		color: '#333',
		textAlign: 'center',
		marginBottom: theme.spacing(3)
	},
	submitButton: {
		backgroundColor: '#004F2B',
		color: '#FFFFFF',
		'&:hover': {
			backgroundColor: '#00391E'
		}
	},
	banner: {
		backgroundColor: 'green',
		color: 'white',
		textAlign: 'center',
		padding: theme.spacing(1),
		marginTop: theme.spacing(2),
		borderRadius: theme.spacing(1)
	},
	shareButtonsContainer: {
		position: 'absolute',
		top: theme.spacing(1),
		right: theme.spacing(1),
		zIndex: 1
	},
	shareMenuItem: {
		padding: theme.spacing(0.5),
		minWidth: 'auto'
	},
	navigation: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
		marginBottom: theme.spacing(3),
		position: 'fixed',
		top: theme.spacing(2),
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: 100,
		backgroundColor: 'rgba(255, 255, 255, 0.85)',
		borderRadius: '12px',
		padding: theme.spacing(0.75),
		boxShadow: '0 2px 8px rgba(0, 79, 43, 0.1)',
		backdropFilter: 'blur(5px)',
		overflowX: 'auto',
		whiteSpace: 'nowrap',
		scrollbarWidth: 'none',
		msOverflowStyle: 'none',
		maxWidth: '900px',
		'&::-webkit-scrollbar': {
			display: 'none'
		},
		[theme.breakpoints.down('md')]: {
			justifyContent: 'space-evenly',
			padding: theme.spacing(0.75, 0),
			maxWidth: '90%',
			borderRadius: '10px'
		},
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(0.5, 0)
		}
	},
	navItem: {
		margin: '0 4px',
		padding: '6px 12px',
		color: '#004F2B',
		fontWeight: 'medium',
		position: 'relative',
		transition: 'all 0.2s ease',
		textDecoration: 'none',
		borderRadius: '8px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 'auto',
		flexShrink: 0,
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: 'rgba(0, 79, 43, 0.05)',
			transform: 'translateY(-2px)'
		},
		'&:active': {
			transform: 'translateY(0px)'
		},
		[theme.breakpoints.down('md')]: {
			margin: '0',
			padding: '6px 8px',
			flexDirection: 'column',
			flex: '1',
			maxWidth: '20%'
		},
		[theme.breakpoints.down('sm')]: {
			padding: '4px 2px'
		}
	},
	navIcon: {
		marginRight: theme.spacing(0.5),
		fontSize: '1.1rem',
		transition: 'transform 0.2s ease',
		[theme.breakpoints.down('md')]: {
			marginRight: 0,
			marginBottom: theme.spacing(0.25),
			fontSize: '1.3rem'
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.1rem',
			marginBottom: theme.spacing(0.25)
		}
	},
	navText: {
		fontSize: '0.85rem',
		fontWeight: 500,
		[theme.breakpoints.up('md')]: {
			fontSize: '0.9rem'
		},
		[theme.breakpoints.down('md')]: {
			fontSize: '0.75rem',
			textAlign: 'center'
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.65rem'
		}
	},
	activeNavItem: {
		backgroundColor: 'rgba(0, 79, 43, 0.08)',
		boxShadow: '0 1px 4px rgba(0, 79, 43, 0.1)',
		'&:after': {
			content: '""',
			position: 'absolute',
			bottom: '4px',
			left: '25%',
			width: '50%',
			height: '2px',
			backgroundColor: '#004F2B',
			borderRadius: '2px'
		},
		'& $navIcon': {
			transform: 'scale(1.1)',
			color: '#003B20'
		},
		'& $navText': {
			color: '#003B20'
		}
	},
	formCard: {
		borderRadius: '15px',
		marginTop: theme.spacing(6),
		marginBottom: theme.spacing(4),
		boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
		overflow: 'visible',
		position: 'relative'
	},
	formCardHeader: {
		backgroundColor: '#004F2B',
		padding: theme.spacing(3),
		color: 'white',
		borderTopLeftRadius: '15px',
		borderTopRightRadius: '15px',
		textAlign: 'center'
	},
	formCardContent: {
		padding: theme.spacing(4)
	},
	scrollToFormButton: {
		backgroundColor: '#004F2B',
		color: 'white',
		'&:hover': {
			backgroundColor: '#003B20'
		},
		borderRadius: '25px',
		padding: '8px 20px',
		marginTop: theme.spacing(2),
		boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
		transition: 'all 0.3s ease'
	}
}));

const useHomeEvaluationStyles = makeStyles((theme) => ({
	dialogPaper: {
		borderRadius: '20px',
		padding: theme.spacing(2),
		maxWidth: '450px',
		width: '95%',
		[theme.breakpoints.down('sm')]: {
			maxWidth: '95%',
			margin: theme.spacing(1),
			borderRadius: '15px'
		}
	},
	dialogTitle: {
		textAlign: 'center',
		position: 'relative',
		paddingBottom: 0
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1)
	},
	evaluationIcon: {
		fontSize: '48px',
		color: '#004F2B',
		marginBottom: theme.spacing(1),
		[theme.breakpoints.down('sm')]: {
			fontSize: '36px',
			marginBottom: theme.spacing(0.5)
		}
	},
	formField: {
		marginBottom: theme.spacing(1.5),
		[theme.breakpoints.down('sm')]: {
			marginBottom: theme.spacing(1)
		}
	},
	submitButton: {
		backgroundColor: '#004F2B',
		color: 'white',
		padding: '12px 30px',
		borderRadius: '30px',
		fontSize: '1rem',
		fontWeight: 600,
		textTransform: 'none',
		boxShadow: '0 4px 10px rgba(0, 79, 43, 0.2)',
		transition: 'all 0.3s ease',
		'&:hover': {
			backgroundColor: '#007542',
			boxShadow: '0 6px 15px rgba(0, 79, 43, 0.3)',
			transform: 'translateY(-2px)'
		}
	},
	dialogContent: {
		padding: theme.spacing(2),
		textAlign: 'center',
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(1.5)
		}
	},
	evaluationText: {
		color: '#004F2B',
		fontWeight: 600,
		fontSize: '1.5rem',
		marginBottom: theme.spacing(2)
	},
	description: {
		marginBottom: theme.spacing(3),
		color: '#637381'
	}
}));

function HomeEvaluationDialog({ open, onClose, onSubmit }) {
	const classes = useHomeEvaluationStyles();
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		phone: ''
	});
	const [errors, setErrors] = useState({});

	const validateForm = () => {
		const newErrors = {};
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		const phoneRegex = /^(?:\(\d{3}\)\s?|^\d{3}[-\s]?)\d{3}[-\s]?\d{4}$/;

		if (!formData.name.trim()) {
			newErrors.name = 'Name is required';
		}
		if (!formData.email.trim()) {
			newErrors.email = 'Email is required';
		} else if (!emailRegex.test(formData.email)) {
			newErrors.email = 'Invalid email format';
		}
		if (formData.phone.trim() && !phoneRegex.test(formData.phone)) {
			newErrors.phone = 'Invalid phone format';
		}

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (validateForm()) {
			onSubmit(formData);
		}
	};

	const handleChange = (field) => (e) => {
		setFormData({ ...formData, [field]: e.target.value });
		if (errors[field]) {
			setErrors({ ...errors, [field]: '' });
		}
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			classes={{ paper: classes.dialogPaper }}
			maxWidth="sm"
			fullWidth
		>
			<DialogTitle className={classes.dialogTitle}>
				<IconButton
					aria-label="close"
					onClick={onClose}
					className={classes.closeButton}
					size="large"
				>
					<CloseIcon />
				</IconButton>
				<Box display="flex" flexDirection="column" alignItems="center">
					<AssessmentIcon className={classes.evaluationIcon} />
				</Box>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<Typography
					variant="h6"
					className={classes.evaluationText}
					style={{ fontSize: '1.25rem', marginBottom: '8px' }}
				>
					💰 Get Your FREE Home Value
				</Typography>
				<Typography
					variant="body2"
					style={{
						color: '#007542',
						fontWeight: 600,
						marginBottom: '12px',
						fontSize: '0.9rem'
					}}
				>
					⭐ $500 Professional Report • Limited Time
				</Typography>
				<Typography
					variant="body2"
					className={classes.description}
					style={{ fontSize: '0.85rem', marginBottom: '12px' }}
				>
					✅ Market value • ✅ Price trends • ✅ Best sell time
				</Typography>
				<form onSubmit={handleSubmit}>
					<TextField
						fullWidth
						label="Name"
						placeholder="Your name"
						variant="outlined"
						value={formData.name}
						onChange={handleChange('name')}
						error={!!errors.name}
						helperText={errors.name}
						className={classes.formField}
						required
						size="small"
						InputProps={{
							startAdornment: (
								<PersonIcon style={{ color: '#004F2B', marginRight: 8 }} />
							)
						}}
					/>
					<TextField
						fullWidth
						label="Email"
						placeholder="your@email.com"
						variant="outlined"
						value={formData.email}
						onChange={handleChange('email')}
						error={!!errors.email}
						helperText={errors.email}
						className={classes.formField}
						required
						size="small"
						InputProps={{
							startAdornment: (
								<EmailIcon style={{ color: '#004F2B', marginRight: 8 }} />
							)
						}}
					/>
					<TextField
						fullWidth
						label="Phone (Optional)"
						placeholder="(555) 123-4567"
						variant="outlined"
						value={formData.phone}
						onChange={handleChange('phone')}
						error={!!errors.phone}
						helperText={errors.phone}
						className={classes.formField}
						size="small"
						InputProps={{
							startAdornment: (
								<PhoneIcon style={{ color: '#004F2B', marginRight: 8 }} />
							)
						}}
					/>
					<Button
						type="submit"
						variant="contained"
						fullWidth
						className={classes.submitButton}
					>
						🏠 Get FREE Home Value
					</Button>
					<Typography
						variant="caption"
						style={{
							color: '#637381',
							textAlign: 'center',
							marginTop: '8px',
							fontSize: '0.7rem'
						}}
					>
						🔒 Secure • 📧 No spam • ⚡ Results in 24hrs
					</Typography>
				</form>
			</DialogContent>
		</Dialog>
	);
}

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null, errorInfo: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error('Error caught by boundary:', error, errorInfo);
		this.setState({ error, errorInfo });
	}

	render() {
		if (this.state.hasError) {
			return <></>;
		}

		try {
			return this.props.children;
		} catch (error) {
			console.error('Direct render error:', error);
			return (
				<Paper
					style={{
						padding: '20px',
						margin: '20px 0',
						backgroundColor: '#fff8f8',
						borderRadius: '8px'
					}}
				>
					<Typography variant="h6" style={{ color: '#d32f2f', marginBottom: '10px' }}>
						{this.props.fallbackText || 'Something went wrong during render.'}
					</Typography>
				</Paper>
			);
		}
	}
}

export default function LeadCapture() {
	const history = useHistory();
	const classes = useStyles();
	const {
		control,
		handleSubmit,
		setValue,
		formState: { errors }
	} = useForm();
	const [orgLogo, setOrgLogo] = useState(null);
	const [address, setAddress] = useState('');
	const [city, setCity] = useState('');
	const [userId, setUserId] = useState('');
	const [homeId, setHomeId] = useState('');
	const [templateId, setTemplateId] = useState('');
	const [orgId, setOrgId] = useState('');
	const [submissionSuccess, setSubmissionSuccess] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [openDialog, setOpenDialog] = useState(false);
	const [ml, setMlNum] = useState('');
	const [listing, setListing] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [activeListings, setActiveListings] = useState([]);
	const [isLoadingActiveListings, setIsLoadingActiveListings] = useState(true);
	const [isLoadingSoldListings, setIsLoadingSoldListings] = useState(true);
	const [soldListings, setSoldListings] = useState([]);
	const [userState, dispatchUser] = useUserState();
	const [showBanner, setShowBanner] = useState(false);
	const isAnyLoading = isLoading || isLoadingActiveListings || isLoadingSoldListings;
	const [hasScrolledToSoldListings, setHasScrolledToSoldListings] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const [activeSection, setActiveSection] = useState(null);
	const marketUpdateRef = useRef(null);
	const nearbyActiveRef = useRef(null);
	const nearbySoldRef = useRef(null);
	const showingTipsRef = useRef(null);
	const propertyDetailsRef = useRef(null);
	const formRef = useRef(null);
	const [showHomeEvaluationDialog, setShowHomeEvaluationDialog] = useState(false);

	const shareUrl = window.location.href;
	const shareTitle = `Check out this property report for ${address}, ${city}`;

	const sectionRefs = useMemo(
		() => ({
			market: marketUpdateRef,
			active: nearbyActiveRef,
			sold: nearbySoldRef,
			tips: showingTipsRef,
			details: propertyDetailsRef
		}),
		[]
	);

	const track = useLeadCaptureTracking({
		userId,
		orgId,
		homeId,
		templateId,
		address,
		city,
		sectionRefs
	});

	const validateName = (value) => {
		const nameRegex = /^[a-zA-Z\s'-]+$/;
		return nameRegex.test(value) || 'Invalid name format';
	};

	const validatePhoneNumber = (value) => {
		const phoneRegex = /^(?:\(\d{3}\)\s?|^\d{3}[-\s]?)\d{3}[-\s]?\d{4}$/;
		return phoneRegex.test(value) || 'Invalid phone number format';
	};

	const validateEmail = (value) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(value) || 'Invalid email address format';
	};

	const handleOpenDialog = () => {
		setOpenDialog(true);
	};

	const handleCloseDialog = () => {
		setOpenDialog(false);
	};

	const handleShareMenuClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleShareMenuClose = () => {
		setAnchorEl(null);
	};

	const scrollToSection = (ref) => {
		window.scrollTo({
			top: ref.current.offsetTop - 120,
			behavior: 'smooth'
		});
	};

	const scrollToForm = useCallback(() => {
		if (formRef.current) {
			formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}, []);

	const renderQuickStats = () => (
		<Box className={classes.quickStats}>
			<Box className={classes.statItem}>
				<BedIcon className={classes.statIcon} />
				<Typography className={classes.statValue}>{listing?.TotBR}</Typography>
			</Box>
			<Box className={classes.statItem}>
				<BathIcon className={classes.statIcon} />
				<Typography className={classes.statValue}>{listing?.TotBaths}</Typography>
			</Box>
			{listing?.NumKitchens > 0 && (
				<Box className={classes.statItem}>
					<KitchenIcon className={classes.statIcon} />
					<Typography className={classes.statValue}>{listing?.NumKitchens}</Typography>
				</Box>
			)}
			<Box className={classes.statItem}>
				<HomeIcon className={classes.statIcon} />
				<Typography className={classes.statValue}>
					{listing?.TotFlArea}
					<span className={classes.statLabel}>sqft</span>
				</Typography>
			</Box>
		</Box>
	);

	const onSubmit = (data) => {
		console.log('Form Data Submitted:', data);

		const fullData = {
			City: city,
			Address: address,
			UserId: userId,
			OrganizationId: orgId,
			HomeId: homeId,
			TemplateId: templateId,
			Data: { Name: data.name, Phone: data.phoneNumber, Email: data.emailAddress }
		};
		console.log('Full Data:', fullData);

		track('form_submit_attempt');

		sendDataToBackend(fullData)
			.then((response) => {
				setSubmissionSuccess(true);
				setErrorMessage('');
				track('form_submit_success');

				const params = new URLSearchParams({
					userid: userId,
					orgId,
					address,
					city,
					homeId,
					templateId
				});
			})
			.catch((error) => {
				console.error('Error sending data:', error);
				setErrorMessage('Error submitting form. Please try again.');
				setSubmissionSuccess(false);
				track('form_submit_error');
			});
	};

	const handleHomeEvaluationSubmit = (data) => {
		const fullData = {
			City: city,
			Address: address,
			UserId: userId,
			OrganizationId: orgId,
			HomeId: homeId,
			TemplateId: templateId,
			Data: { Name: data.name, Phone: data.phone, Email: data.email }
		};

		track('home_evaluation_form_submit_attempt');

		sendDataToBackend(fullData)
			.then((response) => {
				setSubmissionSuccess(true);
				setErrorMessage('');
				setShowHomeEvaluationDialog(false);
				track('home_evaluation_form_submit_success');
			})
			.catch((error) => {
				console.error('Error sending data:', error);
				setErrorMessage('Error submitting form. Please try again.');
				setSubmissionSuccess(false);
				track('home_evaluation_form_submit_error');
			});
	};

	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);

		if (queryParams.get('realtor') !== '1') {
			const setupObserver = () => {
				const soldListingsElement = document.getElementById('lead-nearby-sold-section');

				if (soldListingsElement) {
					const observer = new IntersectionObserver(
						(entries) => {
							console.log('Intersection observed:', entries[0].isIntersecting);
							if (
								entries[0].isIntersecting &&
								!hasScrolledToSoldListings &&
								!openDialog
							) {
								console.log('Triggering scroll to form from observer');
								setHasScrolledToSoldListings(true);
								scrollToForm();
							}
						},
						{ threshold: 0.3 }
					);

					observer.observe(soldListingsElement);
					return observer;
				}
				return null;
			};

			let observer = setupObserver();
			return () => {
				if (observer) {
					const soldListingsElement = document.getElementById('lead-nearby-sold-section');
					if (soldListingsElement) {
						observer.unobserve(soldListingsElement);
					}
				}
			};
		}
	}, [location, hasScrolledToSoldListings, openDialog]);

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const address = queryParams.get('address');
		const city = queryParams.get('city');
		const userId = queryParams.get('userid');
		const homeId = queryParams.get('homeId');
		const orgId = queryParams.get('orgId');
		const templateId = queryParams.get('templateId');
		if (address) setAddress(address);
		if (city) setCity(city);
		if (userId) setUserId(userId);
		if (homeId) setHomeId(homeId);
		if (orgId) setOrgId(orgId);
		if (templateId) setTemplateId(templateId);
		if (orgId || userId) {
			fetchUserDetails(orgId, userId)
				.then((res) => {
					if (res.data.success) {
						const userDetails = res.data.user_details;
						console.log('userDetails::', userDetails);
						const logoPath = require('../../../assets/images/lead_logos/' +
							userDetails.logo);
						setOrgLogo(logoPath);
					}
				})
				.catch((err) => {
					console.error('Error fetching user details:', err);
				});
		}

		if (city && address) {
			setValue('city', city);
			setValue('address', address);
			if (queryParams.get('realtor') !== '1') {
				const payload = {
					City: city,
					Address: address,
					UserId: userId,
					OrganizationId: orgId,
					HomeId: homeId
				};
				if (templateId) {
					payload.TemplateId = templateId;
				}
				sendDataToBackend(payload)
					.then((data) => console.log(data))
					.catch((error) => console.error('Error:', error));
			}
		}
		if (homeId) {
			getMLNumberByHomeIdPropertyReport(homeId)
				.then((response) => {
					if (response.data) {
						console.log(response.data);
						setMlNum(response.data.mlnum);
					}
				})
				.catch((error) => {
					console.error('Error fetching mlNum:', error);
				});
		}
	}, [location, setValue]);

	useEffect(() => {
		const fetchListingData = async () => {
			try {
				const res = await getListingPropertyReport(ml || homeId);
				if (res.status === 200) {
					console.log(res.data.listing);
					setListing(res.data.listing);
				}
			} catch (err) {
				console.error('Error fetching listing:', err.message);
			} finally {
				setIsLoading(false);
			}
		};
		fetchListingData();
	}, [ml]);

	useEffect(() => {
		setIsLoadingActiveListings(true);
		let unmounted = false;
		const fetchData = async () => {
			if (!unmounted && listing && listing.HomeId) {
				getAllNearbyActiveListings(listing.HomeId)
					.then((res) => {
						if (res.status === 200) setActiveListings(res.data.active_listings);
						if (!unmounted) setIsLoadingActiveListings(false);
					})
					.catch((err) => {
						console.log(err);
						if (err.response.status === 401) {
							dispatchUser({
								isLoggedIn: false
							});
							return;
						} else if (!unmounted) {
							setIsLoadingActiveListings(false);
						}
						console.error(err.message);
					});
			} else if (!listing && !unmounted) {
				setIsLoadingActiveListings(false);
			}
		};
		fetchData();
		return () => {
			unmounted = true;
		};
	}, [listing]);

	useEffect(() => {
		setIsLoadingSoldListings(true);
		let unmounted = false;
		const fetchData = async () => {
			if (!unmounted && listing && listing.HomeId) {
				getAllNearbySoldListings(listing.HomeId)
					.then((res) => {
						if (res.status === 200) setSoldListings(res.data.sold_listings);
						if (!unmounted) setIsLoadingSoldListings(false);
					})
					.catch((err) => {
						if (err.response.status === 401) {
							dispatchUser({
								isLoggedIn: false
							});
							return;
						} else if (!unmounted) {
							setIsLoadingSoldListings(false);
						}
						console.error(err.message);
					});
			} else if (!listing && !unmounted) {
				setIsLoadingSoldListings(false);
			}
		};
		fetchData();
		return () => {
			unmounted = true;
		};
	}, [listing]);

	useEffect(() => {
		if (submissionSuccess) {
			setShowBanner(true);
			const timer = setTimeout(() => {
				setShowBanner(false);
			}, 5000); // 5 seconds

			return () => clearTimeout(timer); // Cleanup on unmount or if submissionSuccess changes
		}
	}, [submissionSuccess]);

	useEffect(() => {
		if (address && city) {
			document.title = `Property Report for ${address}, ${city}`;
		} else {
			document.title = 'Property Report';
		}
	}, [address, city]);

	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY + 180;

			const sections = [
				{ id: 'market', ref: marketUpdateRef },
				{ id: 'active', ref: nearbyActiveRef },
				{ id: 'sold', ref: nearbySoldRef },
				{ id: 'tips', ref: showingTipsRef },
				{ id: 'details', ref: propertyDetailsRef }
			].filter((section) => section.ref.current);

			for (let i = sections.length - 1; i >= 0; i--) {
				const section = sections[i];
				if (section.ref.current && scrollPosition >= section.ref.current.offsetTop - 120) {
					setActiveSection(section.id);
					break;
				}
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [listing]);

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const orgId = queryParams.get('orgId');

		if (orgId === '8' || (orgId === '74' && !submissionSuccess)) {
			const timer = setTimeout(() => {
				setShowHomeEvaluationDialog(true);
			}, 3000);

			return () => clearTimeout(timer);
		}
	}, [location, submissionSuccess]);

	return (
		<>
			<CssBaseline />
			<Box className={classes.root}>
				<AppBar position="static" className={classes.appBar}>
					<Toolbar className={classes.toolbar}></Toolbar>
				</AppBar>
				<Container maxWidth="md">
					<img
						src={orgLogo ? orgLogo : DefaultImage}
						alt="Hero"
						className={classes.heroImage}
					/>
					<Grid container justifyContent="center" className={classes.container}>
						<Box className={classes.shareButtonsContainer}>
							<IconButton
								aria-label="share"
								aria-controls="share-menu"
								aria-haspopup="true"
								onClick={handleShareMenuClick}
								size="small"
							>
								<ShareIcon fontSize="small" />
							</IconButton>
							<Menu
								id="share-menu"
								anchorEl={anchorEl}
								keepMounted
								open={Boolean(anchorEl)}
								onClose={handleShareMenuClose}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'right'
								}}
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right'
								}}
							>
								<MenuItem
									onClick={handleShareMenuClose}
									className={classes.shareMenuItem}
								>
									<FacebookShareButton url={shareUrl} quote={shareTitle}>
										<FacebookIcon size={24} round />
									</FacebookShareButton>
								</MenuItem>
								<MenuItem
									onClick={handleShareMenuClose}
									className={classes.shareMenuItem}
								>
									<TwitterShareButton url={shareUrl} title={shareTitle}>
										<TwitterIcon size={24} round />
									</TwitterShareButton>
								</MenuItem>
								<MenuItem
									onClick={handleShareMenuClose}
									className={classes.shareMenuItem}
								>
									<LinkedinShareButton url={shareUrl} title={shareTitle}>
										<LinkedinIcon size={24} round />
									</LinkedinShareButton>
								</MenuItem>
								<MenuItem
									onClick={handleShareMenuClose}
									className={classes.shareMenuItem}
								>
									<WhatsappShareButton
										url={shareUrl}
										title={shareTitle}
										separator=":: "
									>
										<WhatsappIcon size={24} round />
									</WhatsappShareButton>
								</MenuItem>
								<MenuItem
									onClick={handleShareMenuClose}
									className={classes.shareMenuItem}
								>
									<EmailShareButton
										url={shareUrl}
										subject={shareTitle}
										body="Check out this property report:"
									>
										<EmailIcon size={24} round />
									</EmailShareButton>
								</MenuItem>
							</Menu>
						</Box>

						<div style={{ width: '100%', display: 'block', marginBottom: '25px' }}>
							<Typography variant="h5" component="h2" className={classes.title}>
								Here is your Detailed Report for
							</Typography>
						</div>

						{address && (
							<Typography
								variant="h4"
								component="h2"
								className={classes.addressField}
							>
								{address}, {city}
							</Typography>
						)}

						<div style={{ width: '100%', marginTop: '15px' }}>
							{listing && renderQuickStats()}
						</div>

						{/* Navigation Section */}
						{!isAnyLoading && listing && (
							<Fade in={!isAnyLoading} timeout={1000}>
								<Box className={classes.navigation}>
									<Box
										component="a"
										className={`${classes.navItem} ${
											activeSection === 'market' ? classes.activeNavItem : ''
										}`}
										onClick={() => scrollToSection(marketUpdateRef)}
									>
										<TrendingUpIcon className={classes.navIcon} />
										<Typography className={classes.navText}>Market</Typography>
									</Box>
									<Box
										component="a"
										className={`${classes.navItem} ${
											activeSection === 'active' ? classes.activeNavItem : ''
										}`}
										onClick={() => scrollToSection(nearbyActiveRef)}
									>
										<SearchIcon className={classes.navIcon} />
										<Typography className={classes.navText}>Active</Typography>
									</Box>
									<Box
										component="a"
										className={`${classes.navItem} ${
											activeSection === 'sold' ? classes.activeNavItem : ''
										}`}
										onClick={() => scrollToSection(nearbySoldRef)}
									>
										<MonetizationOnIcon className={classes.navIcon} />
										<Typography className={classes.navText}>Sold</Typography>
									</Box>
									<Box
										component="a"
										className={`${classes.navItem} ${
											activeSection === 'tips' ? classes.activeNavItem : ''
										}`}
										onClick={() => scrollToSection(showingTipsRef)}
									>
										<HomeIcon className={classes.navIcon} />
										<Typography className={classes.navText}>Tips</Typography>
									</Box>
									<Box
										component="a"
										className={`${classes.navItem} ${
											activeSection === 'details' ? classes.activeNavItem : ''
										}`}
										onClick={() => scrollToSection(propertyDetailsRef)}
									>
										<AssessmentIcon className={classes.navIcon} />
										<Typography className={classes.navText}>
											Assessment
										</Typography>
									</Box>
								</Box>
							</Fade>
						)}

						{/* Navigation Spacer */}
						{!isAnyLoading && listing && (
							<Box style={{ height: '40px', width: '100%' }} />
						)}

						{showBanner && (
							<Typography variant="h6" className={classes.banner}>
								Form submitted successfully!
							</Typography>
						)}

						{errorMessage && (
							<Typography
								variant="h6"
								style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}
							>
								{errorMessage}
							</Typography>
						)}

						{isAnyLoading ? (
							<Paper className={classes.paper} elevation={3}>
								<Box className={classes.loadingContainer}>
									<Typography variant="h4" className={classes.loadingText}>
										Please wait while we generate your report...
									</Typography>
									<CircularProgress size={40} style={{ color: '#004F2B' }} />
								</Box>
							</Paper>
						) : (
							<>
								{listing && listing?.Region == 'Fraser Valley' && (
									<div ref={marketUpdateRef}>
										<ErrorBoundary fallbackText="Unable to load market update">
											{listing && <LeadMarketUpdate listing={listing} />}
										</ErrorBoundary>
										<ErrorBoundary fallbackText="Unable to load city market update">
											{listing && <LeadCityMarketUpdate listing={listing} />}
										</ErrorBoundary>
									</div>
								)}

								{listing && listing?.Region == 'Greater Vancouver' && (
									<div ref={marketUpdateRef}>
										<ErrorBoundary fallbackText="Unable to load neighborhood market update">
											{listing && (
												<KulbirLeadNeighbourhoodMarketUpdate
													listing={listing}
												/>
											)}
										</ErrorBoundary>
										<ErrorBoundary fallbackText="Unable to load city market update">
											{listing && (
												<KulbirLeadCityMarketUpdate listing={listing} />
											)}
										</ErrorBoundary>
									</div>
								)}
								<div ref={nearbyActiveRef} style={{ marginBottom: 0 }}>
									{!isLoadingActiveListings && activeListings.length > 0 && (
										<>
											<ErrorBoundary fallbackText="Unable to load nearby active listings">
												<Paper className={classes.paper} elevation={3}>
													<LeadNearbyActiveTab
														listing={listing}
														activeListings={activeListings}
														isLoadingActiveListings={
															isLoadingActiveListings
														}
													/>
												</Paper>
											</ErrorBoundary>
											<Box
												display="flex"
												justifyContent="center"
												mt={2}
												mb={0}
												style={{ marginBottom: 12 }}
											>
												<Button
													variant="contained"
													className={classes.scrollToFormButton}
													onClick={scrollToForm}
												>
													Contact Us
												</Button>
											</Box>
										</>
									)}
								</div>

								<div ref={nearbySoldRef} style={{ marginTop: 0 }}>
									{!isLoadingSoldListings && soldListings.length > 0 && (
										<>
											<ErrorBoundary fallbackText="Unable to load nearby sold listings">
												<Paper className={classes.paper} elevation={3}>
													<div id="lead-nearby-sold-section">
														<LeadNearbySoldTab
															listing={listing}
															soldListings={soldListings}
															isLoadingSoldListings={
																isLoadingSoldListings
															}
														/>
													</div>
												</Paper>
											</ErrorBoundary>
											<Box display="flex" justifyContent="center" mt={2}>
												<Button
													variant="contained"
													className={classes.scrollToFormButton}
													onClick={scrollToForm}
												>
													Book Free Consultation
												</Button>
											</Box>
										</>
									)}
								</div>

								<div ref={showingTipsRef}>
									<ErrorBoundary fallbackText="Unable to load showing tips">
										<LeadShowingTips />
									</ErrorBoundary>
								</div>

								<div ref={propertyDetailsRef}>
									<ErrorBoundary fallbackText="Unable to load property details">
										{(() => {
											try {
												return <LeadDetailTab listing={listing} />;
											} catch (error) {
												console.error(
													'Error rendering LeadDetailTab:',
													error
												);
												return (
													<Typography
														variant="body1"
														style={{
															color: '#d32f2f',
															padding: '20px'
														}}
													>
														Error loading property details:{' '}
														{error.message}
													</Typography>
												);
											}
										})()}
									</ErrorBoundary>
								</div>

								{/* Form at the bottom of the page */}
								<div ref={formRef}>
									<ErrorBoundary fallbackText="Unable to load lead capture form">
										<LeadCaptureForm
											address={address}
											city={city}
											onSubmit={handleSubmit(onSubmit)}
											submissionSuccess={submissionSuccess}
											errors={errors}
											control={control}
										/>
									</ErrorBoundary>
								</div>

								<Typography
									variant="body2"
									style={{
										marginTop: '20px',
										padding: '10px',
										backgroundColor: '#f5f5f5',
										color: '#333',
										borderRadius: '5px',
										fontSize: '10px'
									}}
								>
									NOTE: This representation is based in whole or in part on data
									generated by the Chilliwack & District Real Estate Board, Fraser
									Valley Real Estate Board or Real Estate Board of Greater
									Vancouver which assume no responsibility for its accuracy.
								</Typography>
							</>
						)}
					</Grid>
				</Container>
			</Box>
			<HomeEvaluationDialog
				open={showHomeEvaluationDialog}
				onClose={() => setShowHomeEvaluationDialog(false)}
				onSubmit={handleHomeEvaluationSubmit}
			/>
		</>
	);
}
